export const overviewData = {
    service: 'Overview of AC Repair Service',
    overviewComponent: [
      {
        title: "What's Included?",
         listItems : ['Well-trained plumber','Safety Assurance' ]

      },
      {
        title: "What's Excluded?",
         listItems : ['Price of materials or parts',
         "Transportation cost for carrying new materials/parts",
         "Warranty given by manufacturer"]

      },
      {
        title: "Available Services",
         listItems : ['AC Basic Servicing',
         "AC Master Service",
         "AC Water Drop Solution",
         "AC Jet Wash"]

      }
    ]
  }